
<form class="filterForm">
  <mat-grid-list cols="5" rowHeight="4:2">
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Data di Inizio</mat-label>
        <input name="startDate" matInput [matDatepicker]="dateFrom" [(ngModel)]="filters.startDate" #startDate="ngModel">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="dateFrom"></mat-datepicker-toggle>
        <mat-datepicker #dateFrom></mat-datepicker>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Data di Fine</mat-label>
        <input name="endDate" matInput [matDatepicker]="dateTo" [(ngModel)]="filters.endDate" #endDate="ngModel">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="dateTo"></mat-datepicker-toggle>
        <mat-datepicker #dateTo></mat-datepicker>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Severity</mat-label>
        <mat-select name="severity" [(ngModel)]="filters.severity" #severity="ngModel">
          <mat-option value="">NONE</mat-option>
          <mat-option value="DEFAULT">DEFAULT</mat-option>
          <mat-option value="DEBUG">DEBUG</mat-option>
          <mat-option value="INFO">INFO</mat-option>
          <mat-option value="NOTICE">NOTICE</mat-option>
          <mat-option value="WARNING">WARNING</mat-option>
          <mat-option value="ERROR">ERROR</mat-option>
          <mat-option value="CRITICAL">CRITICAL</mat-option>
          <mat-option value="ALERT">ALERT</mat-option>
          <mat-option value="EMERGENCY">EMERGENCY</mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Message</mat-label>
        <input type="text" name="message" matInput [(ngModel)]="filters.textLog" #message="ngModel">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <button mat-flat-button extended (click)="filterLogs()">
        <mat-icon>filter_alt</mat-icon>
        Filtra
      </button>
    </mat-grid-tile>
  </mat-grid-list>
</form>

@if (logs$ | async; as logsData) {
  <div class="table-wrapper crawling_logs_table" (scroll)="onTableScroll($event)" #scrollContainer>
    <table mat-table [dataSource]="logsData" class="mat-elevation-z8">
      <ng-container matColumnDef="logName">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element"> {{element.logName}} </td>
      </ng-container>

      <ng-container matColumnDef="payload">
        <th mat-header-cell *matHeaderCellDef>Message</th>
        <td mat-cell *matCellDef="let element"> {{element.payload.data}} </td>
      </ng-container>

      <ng-container matColumnDef="severity">
        <th mat-header-cell *matHeaderCellDef>Severity</th>
        <td mat-cell *matCellDef="let element"> {{element.severity}} </td>
      </ng-container>

      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element"> {{element.timestamp | date: 'dd/MM/yyyy'}} </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <app-loading [showLoading]="infinityScroll.loading" />
} @else {
  <app-loading [showLoading]="true" />
}
